import { COLOR } from 'Components/Theme';

export const MASTERY_LEVEL = {
  LV1: {
    name: 'เริ่มตั้งไข่',
    color: COLOR.masteryLV1,
  },
  LV2: {
    name: 'ตั้งไข่',
    color: COLOR.masteryLV2,
  },
  LV3: {
    name: 'เข้าใจ',
    color: COLOR.masteryLV3,
  },
  LV4: {
    name: 'เชี่ยวชาญ',
    color: COLOR.masteryLV4,
  },
};
